/**
 * 文字列 関連
 */

import { formatTelNumber } from "./formater";

// 空文字・nullか判定
export const isEmpty = (str) => {
  if (str === "" || str === null || str === undefined) {
    return true;
  } else {
    return false;
  }
}

// 空文字→nullに変換
export const chgEmptyCharToNull = (str) => {
  if (str === "") str = null;
  return str;
}

// 番地・号を合体
export const formatBantGo = (bant, go) => {
  var result = bant;
  if (!isEmpty(go)) result = bant + "-" + go
  return result;
}

// 数値文字列の先頭の0を削除
export const suppressZero = (str) => {
  str = String(str);
  return str.replace(/^0+/, '');
}

// 数値文字列の先頭の0を付与
export const paddingZero = (str) => {
  str = String(str);
  var result;
  str < 10 ? result = "0" + str : result = "" + str;
  return result;
}

// ハイフンを除去
export const replaceHyphens = (number) => {
  if (!isEmpty(number)) return number.replace(/-/g, "");
}

// 住所コード上二桁から都県名称取得
export const getTokenName = (tokenCd) => {

  let tokenName = "";
  switch (tokenCd) {
    case "01": tokenName = "北海道"
      break;
    case "02": tokenName = "青森県"
      break;
    case "03": tokenName = "岩手県"
      break;
    case "04": tokenName = "宮城県"
      break;
    case "05": tokenName = "秋田県"
      break;
    case "06": tokenName = "山形県"
      break;
    case "07": tokenName = "福島県"
      break;
    case "08": tokenName = "茨城県"
      break;
    case "09": tokenName = "栃木県"
      break;
    case "10": tokenName = "群馬県"
      break;
    case "11": tokenName = "埼玉県"
      break;
    case "12": tokenName = "千葉県"
      break;
    case "13": tokenName = "東京都"
      break;
    case "14": tokenName = "神奈川県"
      break;
    case "15": tokenName = "新潟県"
      break;
    case "16": tokenName = "富山県"
      break;
    case "17": tokenName = "石川県"
      break;
    case "18": tokenName = "福井県"
      break;
    case "19": tokenName = "山梨県"
      break;
    case "20": tokenName = "長野県"
      break;
    case "21": tokenName = "岐阜県"
      break;
    case "22": tokenName = "静岡県"
      break;
    case "23": tokenName = "愛知県"
      break;
    case "24": tokenName = "三重県"
      break;
    case "25": tokenName = "滋賀県"
      break;
    case "26": tokenName = "京都府"
      break;
    case "27": tokenName = "大阪府"
      break;
    case "28": tokenName = "兵庫県"
      break;
    case "29": tokenName = "奈良県"
      break;
    case "30": tokenName = "和歌山県"
      break;
    case "31": tokenName = "鳥取県"
      break;
    case "32": tokenName = "島根県"
      break;
    case "33": tokenName = "岡山県"
      break;
    case "34": tokenName = "広島県"
      break;
    case "35": tokenName = "山口県"
      break;
    case "36": tokenName = "徳島県"
      break;
    case "37": tokenName = "香川県"
      break;
    case "38": tokenName = "愛媛県"
      break;
    case "39": tokenName = "高知県"
      break;
    case "40": tokenName = "福岡県"
      break;
    case "41": tokenName = "佐賀県"
      break;
    case "42": tokenName = "長崎県"
      break;
    case "43": tokenName = "熊本県"
      break;
    case "44": tokenName = "大分県"
      break;
    case "45": tokenName = "宮崎県"
      break;
    case "46": tokenName = "鹿児島県"
      break;
    case "47": tokenName = "沖縄県"
      break;
    default:
      tokenName = "";
  }
  return tokenName;
}

/**
 * 引数で渡された電話番号の区分を判定し、返却
 * @param {string} telNo 電話番号
 * @param {string} kbn 「0：固定電話」「1：携帯電話」
 */
export const telKbnCheck = (telNo, kbn) => {

  let result = "";

  // 有効な電話番号かチェック
  if (formatTelNumber(telNo)) {
    if (kbn === "0") {
      // 電話番号が固定電話か判定
      if (telNo.match(/^0(\d-\d{4}|\d{2}-\d{3}|\d{3}-\d{2}|\d{4}[-]?\d)[-]?\d{4}$/)) {
        result = telNo;
      }
    } else {
      // 電話番号が携帯電話か判定
      if (telNo.match(/^0[9876]0[-]?\d{4}[-]?\d{4}$/)) {
        result = telNo;
      }
    }
  }

  return result;
}
